import queryString from 'query-string';
import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';
import { getSSOInfo } from '../hooks/useCredential';

const withSearchParams = (
  mapUrlParamsToFilterState,
  mapFilterStateToUrlParams
) => WrappedComponent => props => {
  const {
    filter,
    initFilterState,
    fetchUserSubscription = () => {},
    featureFlags = {},
    subscription = { data: null },
  } = props || {};
  const history = useHistory();
  const { search, pathname, state } = useLocation();

  useEffect(() => {
    const queryJson = queryString.parse(search);
    const filterState = mapUrlParamsToFilterState(queryJson);

    initFilterState(filterState);
  }, []); // eslint-disable-line

  useEffect(() => {
    const { accessToken, loyaltyId } = getSSOInfo() || {};
    if (
      accessToken &&
      loyaltyId &&
      typeof fetchUserSubscription === 'function' &&
      !isEmpty(featureFlags)
    ) {
      fetchUserSubscription({
        accessToken,
        loyaltyId,
        isHotelListingPage: true,
        isWeb: true,
      });
    }
  }, [JSON.stringify(featureFlags)]);

  useEffect(() => {
    const baseSearchParams = queryString.parse(search);
    const parsedParams = queryString.parse(search);
    const params = new URLSearchParams(search);
    const mftValue = params.get('mft');
    const channelValue = params.get('channel');
    if (mftValue) {
      sessionStorage.setItem('mft', mftValue);
    }
    if (filter.channel && channelValue) {
      sessionStorage.setItem('channel', channelValue);
    }
    const mft = parsedParams.mft || sessionStorage.getItem('mft');
    const channel = parsedParams.channel || sessionStorage.getItem('channel');
    if (filter.isInit) {
      const searchParams = {
        ...baseSearchParams,
        ...mapFilterStateToUrlParams(filter),
        ...(mft && { mft }),
        ...(channel && { channel }),
      };

      history.replace(
        `${pathname}?${queryString.stringify(searchParams)}`,
        state
      );
    }
  }, [filter]); // eslint-disable-line

  return <WrappedComponent {...props} />;
};

export default withSearchParams;
